"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = void 0;
exports.translations = {
    en: {
        h1: "What EZSpeech covers",
        features: {
            1: { title: "Oral-motor exercises", text: "23 exercises" },
            2: {
                title: "Sounds production and automation",
                text: "More that 200 practices",
            },
            3: { title: "Fine motor exercises", text: "6 exercises" },
            4: { title: "Speech Development", text: "More than 300 exercises" },
            5: {
                title: "Personified plan of care and goal settings",
                text: "3-5 per each exercise",
                popUpMessage: "Go to your patient's profile to select exercises for your patients",
            },
            6: {
                title: "Progress  monitoring",
                popUpMessage: "Go to your patient's profile to access their reports",
            },
        },
    },
    ru: {
        h1: "Что включает EZSpeech",
        features: {
            1: { title: "Артикуляционная гимнастика", text: "23 упражнений" },
            2: {
                title: "Отработка и автоматизация звуков",
                text: "Более 200 практик",
            },
            3: {
                title: "Упражнения на мелкую моторику",
                text: "6 упражнений",
            },
            4: { title: "Развитие речи", text: "Более 300 упражнений" },
            5: {
                title: "Индивидуальный план занятий и постановка целей",
                text: "3-5 для каждого упражнения",
                popUpMessage: "Для выбора упражнений зайдите в профиль своего пациента",
            },
            6: {
                title: "Мониторинг результатов",
                popUpMessage: "Для просмотра отчетов зайдите в профиль своего пациента",
            },
        },
    },
};
